
import { Vue, Component, Prop } from 'vue-property-decorator'
import { EApprovalState } from '@/typings/enum'

@Component({
  name: 'PopupState'
})
export default class extends Vue {
  @Prop({ required: true })
  statusId!: number
  @Prop({ required: true })
  status!: string

  render(h: any) {
  /*
    h(tag, options)
  */
    return h('p', {
      // 相当于 v-bind:class
      class: {
        'waiting': this.statusId === EApprovalState.Waiting,
        'processing': this.statusId === EApprovalState.Processing,
        'pass': this.statusId === EApprovalState.Pass,
        'notpass': this.statusId === EApprovalState.NotPass
      },
      domProps: {
        innerText: this.status || ''
      }
    })
  }
}
